import { useEffect, useState } from "react";
import { Form, FormLabel, InputGroup } from "react-bootstrap";

interface TextFormGroupProps {
  title: string,
  initValue: string,
  onSave?: (updatedValue: string) => void,
}
export const TextFormGroup = ({title, initValue, onSave}: TextFormGroupProps) => {
  const [inputValue, setInputValue] = useState<string>(initValue);
  useEffect(() => {
    setInputValue(initValue)
  }, [initValue])
  return (
    <>
      <Form.Group className="mt-4">
        <FormLabel>{title}</FormLabel>
        <InputGroup>
          <Form.Control
            type="text"
            value={inputValue}
            onChange={(e) => {
              e.preventDefault();
              setInputValue(e.target.value)
            }}
          />
          <InputGroup.Text className="cursor-pointer px-3" style={{ borderRadius: '0 12px 12px 0' }} onClick={() => {
            if (!inputValue) return;
            if (onSave) {
              onSave(inputValue);
            }
          }} >變更</InputGroup.Text>
        </InputGroup>
      </Form.Group>
    </>
  )
}